import { render } from "./InvestorTeaser.vue?vue&type=template&id=1490255d"
import script from "./InvestorTeaser.vue?vue&type=script&lang=js"
export * from "./InvestorTeaser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__